import React from 'react';

import PropTypes from 'prop-types';

const AccessDeniedComponent = ({ message, children }) => (
  <div className="flex flex-col items-center max-w-[758px] mt-[5vh] mx-auto p-[5%] bg-white shadow-sm">
    <div className="w-[calc(100%-20px)] max-w-[328px]">
      <img 
        src="/assets/img/logo-rv.png" 
        alt="Logo Rede Vistorias" 
        className="max-w-full max-h-full h-auto"
      />
    </div>
    <p className="max-w-[450px] mt-[4em] text-base text-center text-[#333333]">
      {message}
    </p>
    {children}
  </div>
);

AccessDeniedComponent.propTypes = {
  message: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default AccessDeniedComponent;
